// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zaU2V3dvdwymTcE28V8a{padding-top:9px;height:100%;display:flex;flex-direction:column}.OzrcsYDMQRXeFoX9EzqF{margin:11px 16px 7px}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/integrations/pages/AutomationLogs/ui/AutomationLogsContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,WAAA,CAEA,YAAA,CACA,qBAAA,CAGF,sBACE,oBAAA","sourcesContent":[".container {\n  padding-top: 9px;\n  height: 100%;\n\n  display: flex;\n  flex-direction: column;\n}\n\n.alert {\n  margin: 11px 16px 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zaU2V3dvdwymTcE28V8a`,
	"alert": `OzrcsYDMQRXeFoX9EzqF`
};
export default ___CSS_LOADER_EXPORT___;
